import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {VetClinicService} from "../providers/vet-clinic.service";
import {tap} from "rxjs/operators";
import {AppStateService} from "../providers/app-state.service";
import {VetClinicDgSearchResults} from "../models/datagrid-search-results/vet-clinic.dg-search-results.model";
import {environment} from "../../environments/environment";

@Injectable()
export class VetClinicsResolve  implements Resolve<VetClinicDgSearchResults> {
  constructor(private vetClinicService: VetClinicService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<VetClinicDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.vetClinicService.getResults( environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created', false).pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
